import { EnvironmentType, UserLevel } from '@dxp/core/types';

export interface INavLink {
    routeLink?: string;
    icon: string;
    label: string;
    permission?: string[];
    mode?: 'any' | 'all';
    environments?: EnvironmentType[];
    role?: UserLevel[];
    position: 'menu' | 'footer';
    callback?: () => void;
}

export const navbarLinks: INavLink[] = [
    {
        routeLink: 'dashboard',
        icon: 'fa-house',
        label: 'Home',
        role: ['agent', 'supervisor'],
        position: 'menu',
    },
    {
        routeLink: 'contacts',
        icon: 'fa-light fa-users',
        label: 'Contacts',
        permission: ['customer.read', 'contactdirectory.read'],
        role: ['agent'],
        position: 'menu',
        mode: 'any',
    },
    {
        routeLink: 'performance',
        icon: 'fa-chart-simple',
        label: 'Performance',
        permission: ['reports.read'],
        role: ['supervisor'],
        position: 'menu',
        mode: 'all',
    },
    {
        routeLink: 'contacts',
        icon: 'fa-light fa-users',
        permission: ['customer.read', 'contactdirectory.read'],
        label: 'Contacts',
        role: ['supervisor'],
        position: 'menu',
        mode: 'any',
    },
    {
        routeLink: 'comms/voice/new',
        icon: 'fa-phone',
        label: 'Voice',
        permission: ['voice.read'],
        role: ['agent', 'supervisor'],
        position: 'menu',
        mode: 'all',
    },
    {
        routeLink: 'debug',
        icon: 'fa-debug',
        label: 'Debug',
        environments: [
            EnvironmentType.Dev,
            EnvironmentType.Local,
            EnvironmentType.QA,
        ],
        position: 'menu',
    },
    {
        routeLink: 'examples',
        icon: 'fa-code',
        label: 'Examples',
        environments: [EnvironmentType.Dev, EnvironmentType.Local],
        position: 'menu',
    },
    {
        icon: 'fa-circle-question',
        label: 'Help',
        position: 'footer',
        callback: () => {
            window.open(
                'https://telxlta.mcoutput.com/1390825/Cxp-User-Assistance.htm',
                '_blank',
            );
        },
    },
];
